/**
 * Checkbox customization values are stored as a flat multiset: a selected choice
 * with quantity N appears N times in the `string[]`. This is exactly the shape
 * the ecom `addProduct` contract expects (`OPTIONS.value: string[]`), so the
 * stored value is sent to the cart as-is and `value.length` is the total units.
 */

export const countUnits = (
    value: string[] | undefined,
    label: string,
): number => (value ?? []).filter((v) => v === label).length;

export const setChoiceSelected = (
    value: string[] | undefined,
    label: string,
    selected: boolean,
): string[] => {
    const current = value ?? [];
    if (!selected) {
        return current.filter((v) => v !== label);
    }
    return current.includes(label) ? current : [...current, label];
};

export const changeChoiceQuantity = (
    value: string[] | undefined,
    label: string,
    delta: number,
): string[] => {
    const current = value ?? [];
    if (delta > 0) {
        return [...current, label];
    }
    const lastIndex = current.lastIndexOf(label);
    if (lastIndex === -1) {
        return current;
    }
    return [...current.slice(0, lastIndex), ...current.slice(lastIndex + 1)];
};
